var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M20.9894 5.00994H22.0017C23.1204 5.00994 24.026 5.91553 23.9994 7.00766L23.9992 19.0206C23.9992 20.1127 23.0937 21.0183 22.0015 21.0183H1.99772C0.905584 21.0183 0 20.1127 0 19.0206V7.00766C0 5.91553 0.905584 5.00994 1.99772 5.00994H3.00994V3.99772H5.00766V5.00994H8.0176V2H16.994V5.00994H18.9917V3.99772H20.9894V5.00994Z",
    fill: "#898989"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0206 12.0153H19.844C19.4178 10.8433 18.3256 10.0176 17.0206 10.0176C15.7154 10.0176 14.6234 10.8433 14.1972 12.0153H9.82867C9.40245 10.8433 8.31031 10.0176 7.00528 10.0176C5.70006 10.0176 4.60811 10.8433 4.18188 12.0153H7.00528V14.013H4.20862C4.63484 15.1851 5.72698 16.0107 7.03201 16.0107C8.33723 16.0107 9.42918 15.1851 9.8554 14.013H14.2237C14.65 15.1851 15.7421 16.0107 17.0471 16.0107C18.3524 16.0107 19.4443 15.1851 19.8705 14.013H17.0205L17.0206 12.0153Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings3);
export default __webpack_public_path__ + "static/media/settings3.d0a26fca455dd86b7e9e3834ab22808a.svg";
export { ForwardRef as ReactComponent };